import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-flexbox-grid';

import { GlgIcon } from 'SharedComponents';

const AdvancedFiltersToggle = ({ open, onChange, disabled }) => {
  const handleChange = () => {
    if (!disabled) {
      onChange('advancedFiltersOn', !open);
    }
  };

  const icon = `${open ? 'carret-up' : 'carret-down'}`;
  const iconClass = `${disabled ? '' : 'clickable'}`;

  return (
    <Row>
      <Col>
        <div className="advanced-filters-toggle" onClick={handleChange}>
          <div className="text cursor-default">
            {!window.I18n ? '' : window.I18n.t('customer_directories.filters.advanced_filters_toggle_text')}
          </div>
          <div className="icon" onClick={handleChange}>
            <GlgIcon icon={icon} iconClass={iconClass} />
          </div>
        </div>  
      </Col>
    </Row>
  );
};

AdvancedFiltersToggle.propTypes = {
  open: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default AdvancedFiltersToggle;
